import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import {useLocalStorage} from "../../../utils/useLocalStorage";
import styled from "styled-components";

import {useEffect, useRef, useState} from "react";

import {useNavigate} from 'react-router-dom';
import {Button, TextField, Checkbox} from "@mui/material";
import {useQuery} from "react-query";
import {signIn} from "../../../services/auth";
import {showSnackBar} from "../../Snackbar/Snackbar";
import desktop from "../../../assets/images/Mockup.png";
import bglogin from "../../../assets/images/bg.jpg";

const LoginWrapper = styled.div`
        display: flex;
        min-height: calc(100vh - 120px);
        padding: 20px;
        
        @media (min-width: 768px) {
            padding: 40px;
            margin-top: -121px;
            margin-bottom: -40px;
            padding-right: 0;
        }
        @media  (max-height: 850px){
            min-height: 700px;
        }
    `;

const Container = styled.div`
        font-family: "Gilroy-Regular", sans-serif;
        width: 100%;

        margin: 0 auto;
        display: flex;
        align-items: center;
        @media (min-width: 992px) {
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: center;
            position: relative;
            overflow: hidden;
        }
        @media (max-width: 1100px) {
            grid-template-columns:unset;
        }
    `;

const LoginBox = styled.div`
        //max-width: 600px;
        max-width: 550px;
        margin-left:70px;
        @media (max-width: 700px) {
            padding: 0 50px;
         margin-left: 0;   
        }
        @media (max-width: 1100px) {
            margin: 0 auto;
        }
        @media (max-width: 613px) {
            padding: 0 15px;
        } 
     
        
    `;

const Title = styled.h1`
        font-family: Gilroy-SemiBold, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 40px;
        line-height: 49px;
        color: #000000;
        margin-bottom: 24px;
        @media (min-width: 768px) {
            font-size: 32px;
        }

        @media (min-width: 992px) {
            font-size: 40px;
        }
    `;

const Subtitle = styled.p`
 
        margin-bottom: 32px;
        font-family: 'Gilroy-Medium';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        color: #000000;
        @media (min-width: 768px) {
            font-size: 20px;
        }
    `;

const Form = styled.form`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `;

const ImageContainer = styled.div`
        display: none;
        @media (min-width: 1100px) {
            display: block;
            padding-left: 200px;
            img {
                width: 100%;
                height: auto;
            }
        }
        
    `;

const RememberMe = styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: -8px;
    `;
const BGwrapper = styled.div`
        background: url(${bglogin}) center no-repeat;
        z-index: -1;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-size:  contain;
    `;
const WrapperRoot = styled.div`
        overflow: hidden;
    `;
const BgImg = styled.img`
        position: absolute;
        max-width: 80%;
        height: 100%;
        top: 0;
        right: -31%;
    `;
const TopImg = styled.img`
        position: relative;
        z-index: 1;
    `;

const LoginPage = () => {

    const navigate = useNavigate();

    const [customHeader, setCustomHeader] = useLocalStorage(true);

    const [accessToken, setAccessToken] = useLocalStorage("accessToken", "");
    const [refreshToken, setRefreshToken] = useLocalStorage("refreshToken", "");

    const [userID, setUserID] = useLocalStorage("userID", "");
    const [userEMail, setUserEmail] = useLocalStorage("userEmail", "");
    const [userRole, setRole] = useLocalStorage("role", "");

    const [credentials, setCredentials] = useState({email: '', password: ''})


    const {refetch: fetchSignIn, error,} = useQuery(['sign-in'], () => signIn({credentials}), {
        enabled: false,
        retry: false,
        onSuccess: (data) => {
            setAccessToken(data?.accessToken)
            setRefreshToken(data?.refreshToken)
            setUserID(data?._id)
            setUserEmail(data?.email)
            setRole(data?.role)
            navigate('/dashboard');
            showSnackBar("success", `Login: ${userEMail} successful!`)
        },
        onError: (err) => {
            console.log(err?.response)
            localStorage.clear();
            sessionStorage.clear();
            showSnackBar("error", `Login ${err?.response?.status === 401 ? 'Invalid credentials!' : error?.message}`)
        }
    })
    const handleSignIn = async () => {
        if (!credentials.email || !credentials.password) {
            showSnackBar("error", "Email and password are required!")
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(credentials.email)) {
            showSnackBar("error", "Please enter a valid e-mail address")
            return;
        }

        try {
           const req= await fetchSignIn();
        } catch (error) {
            localStorage.clear();
            sessionStorage.clear();
            return showSnackBar("error", "There was an error logging in. Please try again")
        }
    };

    useEffect(() => {
      if(accessToken?.length > 0  && refreshToken?.length > 0 ){
          navigate('/dashboard');
      }
    }, []);



    useEffect(() => {
        const handleResize = () => {
            if(window.innerWidth < 1099){
                setCustomHeader(false)
            }else {
                setCustomHeader(true)
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (<WrapperRoot>
        <Header white={customHeader} custom={!customHeader}/>
        <LoginWrapper>
            <Container>
                <LoginBox>
                    <Title>Hello, user!</Title>
                    <Subtitle>Currently, only pilot users have access to the platform.
                        <a href="/#subscribe" style={{display:"inline-block", color:"#010035"}}>Subscribe</a> for updates to be the first to get access.</Subtitle>
                    <Form>
                        <TextField
                            fullWidth
                            id="email"
                            label="Login"
                            variant="standard"
                            value={credentials.email}
                            onChange={(e) => setCredentials({...credentials, email: e.target.value})}
                        />
                        <TextField
                            fullWidth
                            id="password"
                            label="Password"
                            type="password"
                            variant="standard"
                            value={credentials.password}
                            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                        />
                        <RememberMe>
                            <Checkbox size="small" />
                            <span>Stay logged in</span>
                        </RememberMe>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={handleSignIn}
                            sx={{
                                padding: '16px 48px',
                                borderRadius: '100px',
                                backgroundColor: '#010035',
                                textTransform: 'none',
                                width: 'fit-content',
                                fontFamily: 'Gilroy-SemiBold',
                                fontSize: '18px',
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: '#010035aa',
                                }
                            }}
                        >
                            Login
                        </Button>
                    </Form>
                </LoginBox>
            <ImageContainer>
                      <BgImg src={bglogin} alt="Dashboard preview" />
                    <TopImg src={desktop} alt="Dashboard preview" />

                </ImageContainer>
            </Container>
        </LoginWrapper>
        <Footer/>
    </WrapperRoot>);
};

export default LoginPage
